function Terms() {
  return (
    <div className="max-w-3xl mx-auto p-6 text-gray-800">
      <h1 className="text-3xl font-bold mb-4">Terms and Conditions</h1>
      <p>
        By accessing and using <strong>Build Pro Resume</strong>, you agree to
        be bound by these terms and conditions. If you do not agree, please do
        not use our services.
      </p>

      <h2 className="text-xl font-semibold mt-6">1. User Responsibilities</h2>
      <p>
        You agree to use our service lawfully and refrain from engaging in any
        activities that may disrupt or harm the platform.
      </p>

      <h2 className="text-xl font-semibold mt-6">2. Intellectual Property</h2>
      <p>
        All content, branding, and resources on this platform are the exclusive
        property of <strong>Build Pro Resume</strong>. You may not copy,
        reproduce, or distribute any content without prior written permission.
      </p>

      <h2 className="text-xl font-semibold mt-6">3. Service Modifications</h2>
      <p>
        We reserve the right to modify or discontinue any part of our service at
        any time, with or without notice.
      </p>

      <h2 className="text-xl font-semibold mt-6">4. Limitation of Liability</h2>
      <p>
        Build Pro Resume shall not be held liable for any damages resulting from
        the use or inability to use our services.
      </p>

      <h2 className="text-xl font-semibold mt-6">5. Contact Us</h2>
      <p>
        If you have any questions about these terms, feel free to reach out to
        us at
        <span className="text-blue-600"> support@buildproresume.com</span>.
      </p>
    </div>
  );
}

export default Terms;
